import { User } from '../../entities/User';
import { api } from '../api';

export const getUser = async (): Promise<User> => {
  const { data } = await api.get('/users');

  return data;
};
